import { SpinnerWrapper, Dot } from './LoadingSpinner.styles';
import { useTheme } from 'styled-components';

export default function LoadingSpinner() {
  const theme = useTheme();

  return (
    <SpinnerWrapper>
      <Dot delay="0s" color={theme.colors.primary} />
      <Dot delay=".1s" color={theme.colors.primaryAccent} />
      <Dot delay=".2s" color={theme.colors.muted} />
    </SpinnerWrapper>
  );
}